
export const defaultColorPreset = [
    '#C5EBE3',
    '#E8C792',
    '#D4EBFA',
    '#99AEF2',
    '#F7DFE2',
    '#D9A7A7',
    '#F2E205',
    '#B8D9B8',
    '#DBCDA4',
    '#CFCA4C',
    '#9CBCB7',
    '#FFFFFF',
    '#000000',
    '#D97EF2',
    '#36D9C3',
    '#ABD907',
]